import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { locale, t as tr } from "@/i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      const org = sessionStorage.getItem("smboi-org");
      if (org) cfg.headers["X-Org-Id"] = org;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const errMsg = (e) => e?.response?.data?.detail || e?.message || tr("Something went wrong");

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString(locale(), { year: "numeric", month: "short", day: "numeric" }) : "—";
